import {
  Image_Url,
  SportImage_Url,
  LeagueImage_Url,
} from "../../constant/Environment";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import axios from "axios";
import { Actions } from "../../redux/Actions/Actions";
export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
};

export const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export const formatPlayerData = (data, martketIdArray = []) => {
  let formattedData = [];

  data.forEach((element) => {
    const { sport, location, league, startDate, participants } =
      element.fixture;
    let tempData = {};
    let marketfilteredData = element?.markets?.filter((marketEle) => {
      return martketIdArray.includes(marketEle.id);
    });

    const key = "id";
    let uniqueArr = [
      ...new Map(marketfilteredData?.map((item) => [item[key], item])).values(),
    ];

    uniqueArr = updateArray(uniqueArr, martketIdArray);

    let priority = [2, 1];
    let participantList = checkPosition(participants, priority);
    tempData.marketData = element?.markets; //uniqueArr;
    tempData.sport = sport;
    tempData.location = location;
    tempData.league = league;
    tempData.participants = participantList;
    tempData.startDate = startDate;
    tempData.fixtureId = element.fixtureId;
    tempData.id = element.id;
    tempData.goLive = element.fixture.goLive;
    if (tempData.marketData.length > 0) {
      formattedData.push(tempData);
    }
  });

  return formattedData;
};

export const formatApiData = (data, martketIdArray) => {
  let formattedData = [];

  data.forEach((element) => {
    const { sport, location, league, startDate, participants } =
      element.fixture;

    let tempData = {};
    let marketfilteredData = element?.markets?.filter((marketEle) => {
      return martketIdArray.includes(marketEle.id);
    });

    const key = "id";
    let uniqueArr = [
      ...new Map(marketfilteredData?.map((item) => [item[key], item])).values(),
    ];

    uniqueArr = updateArray(uniqueArr, martketIdArray);

    let priority = [2, 1];
    let participantList = checkPosition(participants, priority);
    tempData.marketData = uniqueArr;
    tempData.sport = sport;
    tempData.location = location;
    tempData.league = league;
    tempData.participants = participantList;
    tempData.startDate = startDate;
    tempData.fixtureId = element.fixtureId;
    tempData.id = element.id;
    tempData.goLive = element.fixture.goLive;
    if (tempData.marketData.length > 0) {
      formattedData.push(tempData);
    }
  });

  return formattedData;
};

export const formatWagerData = (data, martketIdArray) => {
  let formattedData = [];

  data.forEach((element) => {
    const { sport, location, league, startDate, participants } =
      element.fixture;

    let tempData = {};
    let marketfilteredData = element.markets.filter((marketEle) => {
      return martketIdArray.includes(marketEle.id);
    });

    const key = "id";
    let uniqueArr = [
      ...new Map(marketfilteredData.map((item) => [item[key], item])).values(),
    ];

    uniqueArr = updateArray(uniqueArr, martketIdArray);

    let priority = [2, 1];
    let participantList = checkPosition(participants, priority);
    tempData.marketData = uniqueArr;
    tempData.sport = sport;
    tempData.location = location;
    tempData.league = league;
    tempData.participants = participantList;
    tempData.startDate = startDate;
    tempData.fixtureId = element.fixtureId;
    tempData.id = element.id;

    formattedData.push(tempData);
  });

  return formattedData;
};
export const groupByCategory = (arr) => {
  return arr.reduce((result, item) => {
    const category = item.seasonal_role;
    if (!result[category]) {
      result[category] = [];
    }
    result[category].push(item);
    return result;
  }, {});
};
export const getHeaderName = (name) => {
  switch (name) {
    case "batsman":
      return "Batsman";
    case "bowler":
      return "Bowler";
    case "keeper":
      return "Keeper";
    case "all_rounder":
      return "All Rounder";
    default:
      return "";
  }
};
export const formatEventIdData = (data, martketIdArray, eventId) => {
  let formattedData = [];

  data.forEach((element) => {
    const { sport, location, league, startDate, participants } =
      element.fixture;
    const EventId = element.fixtureId;
    if (EventId === eventId) {
      let tempData = {};
      let marketfilteredData = element.markets.filter((marketEle) => {
        return martketIdArray.includes(marketEle.id);
      });

      const key = "id";
      let uniqueArr = [
        ...new Map(
          marketfilteredData.map((item) => [item[key], item])
        ).values(),
      ];

      uniqueArr = updateArray(uniqueArr, martketIdArray);

      let priority = [2, 1];
      let participantList = checkPosition(participants, priority);
      tempData.marketData = uniqueArr;
      tempData.sport = sport;
      tempData.location = location;
      tempData.league = league;
      tempData.participants = participantList;
      tempData.startDate = startDate;
      tempData.fixtureId = element.fixtureId;
      tempData.id = element.id;

      formattedData.push(tempData);
    }
  });

  return formattedData;
};

const updateArray = (arr, arr2) => {
  return arr.sort((a, b) => arr2.indexOf(a.id) - arr2.indexOf(b.id));
};

const checkPosition = (arr, arr2) => {
  return arr.sort(
    (a, b) =>
      arr2.indexOf(parseInt(a.position)) - arr2.indexOf(parseInt(b.position))
  );
};

const checkBetName = (arr) => {
  arr.map((value, index) => {
    if (value.id == 28) {
      value.bets.sort((a, b) => {
        let fa = a.name.toLowerCase(),
          fb = b.name.toLowerCase();
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    }
  });
  return arr;
};

export const calculateOdds = (odds, stake) => {
  if (odds >= 0) {
    let total = stake * (odds / 100) + Number(stake); //5*(220/100)+5
    return total.toFixed(2);
  } else {
    let total = stake / (Math.abs(odds) / 100) + Number(stake);
    return total.toFixed(2);
  }
};

export const calculateReverseOdds = (odds, towin) => {
  if (odds >= 0) {
    return towin / (odds / 100) + 1;
  } else {
    return (towin * (odds / 100)) / (1 + odds / 100);
  }
};
export const calculateAllReverseOdds = (odds, stake) => {
  if (odds >= 0) {
    return stake * (odds / 100) + Number(stake); //5*(220/100)+5
  } else {
    return stake / (Math.abs(odds) / 100) + Number(stake);
  }
};
export const calculateAllOdds = (odds, stake) => {
  let totalodds = 1;
  let money = 1;
  let spread = 1;
  let total = 1;
  let usodds;
  odds.map((item) => {
    let first = item.t1Spread2 ?? item.tHome ?? item.priceUS;
    let second = item.t1Money2 ?? item.tTie;
    let third = item.t1Total2 ?? item.tAway;

    if (first != undefined) {
      if (first >= 0) {
        spread = (first / 100 + 1) * spread;
      } else {
        spread = (1 - 100 / first) * spread;
      }
    } else if (second != undefined) {
      if (second >= 0) {
        money = (second / 100 + 1) * money;
      } else {
        money = (1 - 100 / second) * money;
      }
    } else {
      if (third >= 0) {
        total = (third / 100 + 1) * total;
      } else {
        total = (1 - 100 / third) * total;
      }
    }
  });

  totalodds = spread * money * total;

  usodds = (totalodds - 1) * 100;

  var underdog = calculateOdds(usodds, stake);
  return underdog;
};

// filter data on the basis of event id
export const filterEventData = (data, multipleEventId) => {
  return data.map((item) => {
    const newdata = item.markets.filter((element) =>
      multipleEventId.includes(element.id)
    );
    return {
      fixtureId: item.fixtureId,
      markets: newdata,
    };
  });
};

export const getImageUrl = (name, sportName) => {
  let tempNmae = name?.replace(". ", ".").replace(/[^\w]/g, "_")?.toLowerCase();
  if (sportName === "National Collegiate Athletic Association (NCAA)") {
    sportName = "ncaaf";
  }
  let imageUrl =
    `${Image_Url}` + sportName?.toLowerCase() + "/" + tempNmae + ".png";
  return imageUrl;
};

export const getSportImageUrl = (sportName) => {
  let imageUrl = `${SportImage_Url}` + sportName?.toLowerCase() + ".svg";
  return imageUrl;
};

export const getLeagueImageUrl = (sportName) => {
  let imageUrl = `${LeagueImage_Url}` + sportName?.toLowerCase() + ".svg";
  return imageUrl;
};

export const getMarketSingleData = (data) => {
  let newmarket = [];
  data.forEach((element) => {
    if (element.markets.length > 0) {
      element.markets.map((item, index) => {
        if (newmarket.length == 0) {
          newmarket.push({
            id: `${element.id}_${index}`,
            name: item.statName,
          });
        } else {
          let filterData = newmarket.filter((d) => d.name == item.statName);

          if (filterData.length == 0) {
            newmarket.push({
              id: `${element.id}_${item.id}`,
              name: item.statName,
            });
          }
        }
      });
    }
  });
  return newmarket;
};

export const getMatchListData = (data, activeTabDate) => {
  // console.log(data,activeTabDate);
  let newTeam = [];
  let updated = data.filter((item) => item.displayDate == activeTabDate);
  updated.map((item, index) => {
    newTeam.push({
      id: `${item.id}`,
      name: item.eventName,
      shortname: item.shortEventName,
    });
  });
  // console.log('newTeam', newTeam)
  return newTeam;
};

export const getKeyPairList = (data) => {
  let newTeam = [];

  data.map((item, index) => {
    newTeam.push({
      id: `${index}`,
      name: item,
    });
  });

  return newTeam;
};

export const getdate = (data) => {
  let data_array = [];

  data.map((item, index) => {
    data_array.push({
      id: `${index}`,
      name: item.openDate,
      games: item.eventName,
      shortdate: item.displayDate,
    });
  });

  return data_array;
};

export const setCookie = (name, value, days) => {
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + expirationDate.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

export const getCookie = (name) => {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return "";
};

export const validateNoSpecialChar = (value) => {
  // contains only letters and numbers
  const regex = /^[a-zA-Z0-9]+$/;
  return regex.test(value) ? false : true;
};

export const validateEmail = (emailAdress) => {
  let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailAdress.match(regexEmail)) {
    return true;
  } else {
    return false;
  }
};

export const validateOnlyLetters = (value) => {
  // contains only letters
  const regex = /^[a-zA-Z ]+$/;
  return regex.test(value) ? false : true;
};

export const validatePassword = (password) => {
  // Regular expression pattern for password validation
  const regex =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

  // Test the password against the regex pattern
  return regex.test(password);
};

export const formatAmount = (amount) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const checkGeoAndVpn = async (dispatch, expectedCountryCode = "US") => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.log("Geolocation not supported");
      resolve(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          console.log("Lat:", latitude, "Lng:", longitude);

          // Reverse geocoding call
          const locationData = await getAddressFromCoords(latitude, longitude);
          const userCountry = locationData.country;
          const RegionCode =  locationData.stateCode;
          
          // You can now play in AK, CA, DC, GA, IL, KS, KY, MN, ND, NE, NM, OK, OR, RI, SC, SD, TX, UT, WI & VT.(allowed regions for reference)

          const notAllowedRegions = [
            "AL",
            "AR",
            "AZ",
            "CO",
            "CT",
            // "DC",
            "DE",
            "FL",
            "HI",
            "IA",
            "IN",
            "LA",
            "MA",
            "MD",
            "ME",
            "MI",
            "MO",
            "MS",
            "MT",
            "NC",
            "NH",
            "NJ",
            // "NM",
            "NV",
            "NY",
            "OH",
            "PA",
            // "RI", 
            "TN",
            "VA",
            // "VT",
            "WA",
            "WV",
            "WY",
          ];
          const result = notAllowedRegions.includes(RegionCode);

          const isVpn = false; // You can integrate VPN API check here if needed
          // dispatch(setVPNResponse(isVpn));

          const checkUserCountry =
            userCountry === expectedCountryCode ? result : false;

          resolve(checkUserCountry);
        } catch (err) {
          console.error("Error during reverse geocoding or processing:", err);
          resolve(false);
        }
      },
      (error) => {
        console.error("Location error:", error.message);
        resolve(false);
      }
    );
  });
};

async function getAddressFromCoords(lat, lng) {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
  );
  const data = await response.json();
  const address = data.address;

  const state = address.state || "";
  const country = address.country_code?.toUpperCase() || ""; // e.g., IN, US

  // Optional: Map state name → state code manually
  const stateCode =
    country == "US" ? getStateCodeFromName(state, country) : state;
  // console.log("stateCode", stateCode, "country", country);
  return {
    city: address.city || address.town || address.village || "",
    state,
    stateCode: country == "US" ? stateCode : state,
    country,
  };
}

const STATE_CODES = {
  IN: {
    Maharashtra: "MH",
    Karnataka: "KA",
    Delhi: "DL",
  },
  US: {
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    Washington: "WA",
    "West Virginia": "WV",
    Wisconsin: "WI",
    Wyoming: "WY",
  },
};

function getStateCodeFromName(stateName, countryCode) {
  return STATE_CODES[countryCode]?.[stateName] || "";
}
